import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { useState } from 'react';

const InstallButton = () => {
  const { canInstall, isInstalled, isIOS, promptInstall } = useInstallPrompt();
  const [showIOSHint, setShowIOSHint] = useState(false);

  if (isInstalled || !canInstall) return null;

  const handleClick = () => {
    if (isIOS) {
      setShowIOSHint(true);
      return;
    }
    promptInstall();
  };

  return (
    <div className="relative">
      <button
        onClick={handleClick}
        className="text-xs md:text-base font-bold underline cursor-pointer"
      >
        Install App
      </button>
      {showIOSHint && (
        <div className="absolute bottom-full mb-2 right-0 bg-white text-black text-xs p-2 rounded shadow-lg w-48">
          Tap the Share icon, then "Add to Home Screen"
          <button onClick={() => setShowIOSHint(false)} className="block mt-1 underline">
            Got it
          </button>
        </div>
      )}
    </div>
  );
};

export default InstallButton;
